(() => {
  const MAG_TYPE = 'Magazine';
  const COLLECTION_URL = '/collections/magazine';
  const COLLECTION_IMAGE_URL =
    'https://cdn.shopify.com/s/files/1/0501/0541/7885/files/Mag_1-14.jpg?v=1760503273';

  const getCart = async () => {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Failed to load cart');
    return res.json();
  };

  const buildCard = (imgUrl) => {
    const wrap = document.createElement('div');
    wrap.className = 'nts-mag-upsell';
    wrap.innerHTML = `
      <div class="nts-mag-upsell__card">
        <h3 class="nts-mag-upsell__heading">Get 20% off back issues</h3>

        <div class="nts-mag-upsell__row">
          <a class="nts-mag-upsell__imgwrap" href="${COLLECTION_URL}">
            ${
              imgUrl
                ? `<img class="nts-mag-upsell__img" src="${imgUrl}" alt="Magazines" loading="lazy">`
                : `<div class="nts-mag-upsell__img nts-mag-upsell__img--placeholder" aria-hidden="true"></div>`
            }
          </a>

          <div class="nts-mag-upsell__content">
            <div class="nts-mag-upsell__text">
              Mix and match any issues. Discount applied automatically.
            </div>

            <a class="nts-mag-upsell__btn element-button" href="${COLLECTION_URL}">
              Shop Magazines
            </a>
          </div>
        </div>
      </div>
    `;
    return wrap;
  };

  const ensureStyles = () => {
    if (document.getElementById('nts-mag-upsell-styles')) return;

    const style = document.createElement('style');
    style.id = 'nts-mag-upsell-styles';
    style.textContent = `
      .nts-mag-upsell { margin: 12px 0 16px; padding-bottom: 20px; }

      .nts-mag-upsell__card{
        border: 1px solid rgba(0,0,0,.10);
        border-radius: 0; /* square corners */
        background: var(--color-secondary, #fff);
        color: var(--color-primary, #111);
        box-shadow: 0 10px 22px rgba(0,0,0,.08);
        padding: 16px;
        font-family: var(--element-text-font-family--body, inherit);
        letter-spacing: var(--element-text-letter-spacing--body, normal);
        line-height: var(--element-text-line-height--body, 1.4);
      }

      .nts-mag-upsell__heading{
        margin: 0 0 12px;
        text-align: center;
        font-family: var(--element-text-font-family--heading, inherit);
        font-weight: var(--element-text-font-weight--heading, 700);
        letter-spacing: var(--element-text-letter-spacing--heading, normal);
        text-transform: var(--element-text-text-transform--heading, none);
        font-size: var(--element-text-font-size--heading-md, 20px);
        line-height: var(--element-text-line-height--heading, 1.3);
      }

      .nts-mag-upsell__row{
        display: grid;
        grid-template-columns: 96px 1fr;
        gap: 14px;
        align-items: center;
      }

      .nts-mag-upsell__img{
        width: 96px;
        height: 96px;
        object-fit: cover;
        border-radius: 0; /* square corners */
        background: rgba(0,0,0,.05);
        display: block;
      }

      .nts-mag-upsell__img--placeholder{
        width: 96px;
        height: 96px;
        border-radius: 0; /* square corners */
        border: 1px dashed rgba(0,0,0,.20);
        background: rgba(0,0,0,.03);
      }

      .nts-mag-upsell__text{
        font-size: var(--element-text-font-size--body-md, 16px);
        line-height: var(--element-text-line-height--body, 1.4);
        margin-bottom: 12px;
      }

      /* Button uses theme vars for background/radius, but forces WHITE text for contrast */
      .nts-mag-upsell__btn{
        display: block;
        text-align: center;
        text-decoration: none;

        border-radius: var(--element-button-radius, 0);
        padding: 14px 16px;

        font-family: var(--element-button-font-family, inherit);
        font-weight: var(--element-button-font-weight, 700);
        letter-spacing: var(--element-button-letter-spacing, normal);
        text-transform: var(--element-button-text-transform, none);

        background: var(--element-button-color-primary, #111);
        color: #fff !important;

        box-shadow: var(--element-button-box-shadow, inset 0 0 0 1px rgba(0,0,0,.2));
      }

      .nts-mag-upsell__btn:visited{
        color: #fff !important;
      }

      .nts-mag-upsell__btn:hover{
        filter: brightness(0.98);
      }
    `;
    document.head.appendChild(style);
  };

  const insertOrRemove = async () => {
    const drawer = document.getElementById('CartDrawer');
    const productsRoot = drawer?.querySelector('[data-products]');
    const itemsWrap = productsRoot?.querySelector('.cart__items');
    if (!drawer || !productsRoot || !itemsWrap) return;

    const cart = await getCart();
    const magItems = cart.items.filter((it) => (it.product_type || '').trim() === MAG_TYPE);

    // Remove card if no magazines
    if (magItems.length === 0) {
      productsRoot.querySelector('.nts-mag-upsell')?.remove();
      return;
    }

    // Prevent duplicates
    if (productsRoot.querySelector('.nts-mag-upsell')) return;

    ensureStyles();

    // Insert above first magazine item using Shopify line item key (matches .cart__item[data-key])
    const firstMag = magItems[0];
    const key = firstMag.key;
    const anchor = key ? itemsWrap.querySelector(`.cart__item[data-key="${CSS.escape(key)}"]`) : null;

    const card = buildCard(COLLECTION_IMAGE_URL);

    if (anchor?.parentNode) anchor.parentNode.insertBefore(card, anchor);
    else itemsWrap.prepend(card);
  };

  const boot = () => {
    const drawer = document.getElementById('CartDrawer');
    const productsRoot = drawer?.querySelector('[data-products]');
    if (!drawer || !productsRoot) return;

    // Motion re-renders cart items; observe and re-insert when needed
    const obs = new MutationObserver(() => {
      insertOrRemove().catch(() => {});
    });
    obs.observe(productsRoot, { childList: true, subtree: true });

    insertOrRemove().catch(() => {});
  };

  document.addEventListener('DOMContentLoaded', boot);
})();
